import React, { useEffect, useState, useCallback } from "react";
import moment from "moment";
import { useTranslation } from 'react-i18next';
import { useStoreState, useStoreActions } from 'easy-peasy';

import { Row, Col } from "stories/layout";
import { Input } from "stories/forms";
import { Card, Typography, Button, Link, IconButton, Modal, Spinner, BreadcrumbsDynamic } from "stories/components";
import { PageHeader, PageContainer } from "components/Page"
import { TableAuto } from "stories/tables"
import { httpGetExtendBasicData, httpGetBasicData} from "services/stocks"
import { httpGetStockData } from "services/stocks"
import OptionEdit from "views/app/OptionEdit/OptionEdit"
import { thousandFormat, roundScaleDecimals } from "services/helpers";
        
import StockMarketSelect from "components/Forms/StockMarketSelect/StockMarketSelect"
import CurrencySelect from "components/Forms/CurrencySelect/CurrencySelect" 
        

import { useAppContext } from "contexts/AppContext"
import { Pagination } from "stories/tables";


const StocksList = ({match, history, location}) => {
  
  const { t } = useTranslation();
  // const stocks = useStoreState((state) => state.stocks?.objects);
  // const loading = useStoreState((state) => state.stocks?.loading);
  const getBasicDataObjects = useStoreActions((actions) => actions.stocks.getObjects);
  // const count = useStoreState((state) => state.stocks?.count);
  const { getStockMarketName } = useAppContext()
  const [stocks, setStocks] = useState()
  const [count, setCount] = useState(0)
  const [loading, setLoading] = useState(false)


  const getOptions = () => {
    // setRows(exampleData);
    // setCount(exampleData.length)
    // setOptions(exampleData)
    // setCount(exampleData.length)
  }
  
  // Table
  // const [rows, setRows] = useState([])
  // const [count, setCount] = useState(0)
  const [filters, setFilters] = useState({
    limit: 30,
    offset:0,
    stock_market: "XHEL",
    hide: null,
  })

  const getCrumbLinks = () => {
    const crumbLinks = [
      {name: t("Etusivu"), url: "/dashboard/"},
      {name: t("StocksList_title","Noteeratut osakkeet (NASDAQ)"), url: "/dashboard/stocks", optional: true, passed: true},
      {name: getStockMarketName(filters.stock_market), url: "/dashboard/stocks", optional: true, passed: false},

    ]

    //if location state include crumbLinks return them
    if (location?.state && location?.state?.crumbLinks) {
      const crumbLinks = [...location.state.crumbLinks]

      crumbLinks.push({name: t("StocksList_title","Noteeratut osakkeet (NASDAQ)"), url: "/dashboard/stocks"})
      crumbLinks.push({name: getStockMarketName(filters.stock_market), url: "/dashboard/stocks", optional: true})
      return crumbLinks
    }
    //else return default links
    return crumbLinks
  }



  
  useEffect(() => {
    const params = {...filters}
    params.ordering = "name"
    params.hide = params.hide? moment(params.hide).format("YYYY-MM-DD"): null
    delete params.limit
    getBasicDataObjects(params)
    setLoading(true)
    params.limit = filters.limit
    httpGetBasicData(params).then(res => {
      setStocks(res.data?.results)
      setCount(res?.data?.count)
      setLoading(false)

    })
  }, [filters])
  
  const handleChange = ({target}) => {
    setFilters({
      ...filters,
      [target.name]: target.value,
    })
  }
  
  const headers = [
    { label: t("stocks_list_name", "name"), key: "name"},
    { label: t("stocks_list_stock_date", "Kirjaus päivä"), key: "stock_date"},
    { label: t("stocks_list_updated_opening_price", "Avaus hinta"), key: "updated_opening_price"},
    { label: t("updated_stocks_list_highest_price", "Ylin hinta"), key: "updated_highest_price"},
    { label: t("stocks_list_lowest_price", "Alin hinta"), key: "updated_lowest_price"},
    { label: t("stocks_list_ending_price", "Päätös hinta"), key: "updated_ending_price"},
    { label: t("stocks_list_currency", "Valuutta"), key: "trading_currency"},


    { label: t("stocks_list_industry", "industry"), key: "industry"},
    { label: t("stocks_list_isin", "isin"), key: "isin"},
    { label: t("stocks_list_listing_date", "listing_date"), key: "listing_date"},
    // { label: t("stocks_list_listing_number", "listing_number"), key: "listing_number"},
    // { label: t("stocks_list_size", "size"), key: "size"},
    { label: t("stocks_list_stock_market", "stock_market"), key: "stock_market"},
    { label: t("stocks_list_stocks", "stocks"), key: "stocks"},
    { label: t("stocks_list_ticker_symbol", "ticker_symbol"), key: "ticker_symbol"},
    { label: t("stocks_list_actions", " "), key: "actions"},


  ];
  
  const paginationPrevious = () => {
    let offset = filters?.offset - Number(filters?.limit);
    if (offset < 0) {
      offset = 0;
    }
    setFilters(f => ({
      ...f,
      offset: offset,
    }))
  }
  
  const paginationNext = () => {
    let offset = filters?.offset + Number(filters?.limit);
    if (offset > filters?.count) {
      return
    }
    setFilters(f => ({
      ...f,
      offset: offset,
    }))
  }
  



  const getLatestStockDataUpdateDate = useCallback (() => {
    //time now
    const now = moment()

    let oldestDate= null
    let ThereIsNull = false
    
    if (stocks?.length > 0 && stocks?.[0]?.stock_data_latest?.stock_date) {
      //loop all stocks and get oldest stock date
      stocks.forEach(stock => {
        if (stock?.stock_data_latest?.stock_date) {
          const stockDate = moment(stock?.stock_data_latest?.stock_date)
          if (!oldestDate) {
            oldestDate = stockDate
          }
          if (stockDate.isBefore(oldestDate)) {
            oldestDate = stockDate
          }
          if (stockDate === null) {
            ThereIsNull = true
          }
        }
      })
    }


    //get latest stock data update date
    const latestStockDataUpdateDate = oldestDate
    let endOfInfoText = t("stocks_list_minutes_ago", "minuuttia sitten")
    //get difference between now and today start
    const diffNowAndTodayStart = now.diff(moment().startOf('day'), 'minutes')
    let styles = "text-success"

    //get difference between now and latest stock data update date
    let diff = now.diff(latestStockDataUpdateDate, 'minutes')

    // latestStockDataUpdateDate are older than yesterday at 20:00.
    if (diffNowAndTodayStart  + 240 < diff || oldestDate === null) {
      styles = "text-danger"
    }
    if (diff > 1440) {
      diff = now.diff(latestStockDataUpdateDate, 'days')
      endOfInfoText = t("stocks_list_days_ago", "päivää sitten")
    }
    else if (diff > 60) {
      diff = now.diff(latestStockDataUpdateDate, 'hours')
      endOfInfoText = t("stocks_list_hours_ago", "tuntia sitten")
    }

    // Now return empty, because feature is not ready yet
    return(<></>)

    return (
      <>
      {!loading && (
        <div className={`d-flex ${styles}`}>
        <i className="fas fa-history pr-1"/>
        {ThereIsNull ? (<Typography variant="h5" className="text-danger">{t("stocks_list_some_stocks_are_missing_data", "Joidenkin osakkeiden kurssidata vaillinaista")}</Typography>)
        : (<Typography variant="h5" className={styles}>{t("Päivitetty")} {diff} {endOfInfoText}</Typography> )}
        
        </div>
        )
      }
      </>
    )
  }, [stocks, loading])



  const getTableRows = useCallback(() => {
    //map all crumbs and return only key "passed" : true or undefined. Then set optional to false, so they are links then
    const getPassedCrumbLinks = () => {
      const crumbLinks = getCrumbLinks().filter(item => item?.passed === true || item?.passed === undefined).map(item => {
          return {
            ...item,
            optional: false,
          }
      })
      return crumbLinks
    }
    return stocks && stocks.map((row, index) => {
      return {
        ...row,
        name: (
          <Link to={{pathname:"/dashboard/stocks/rates/rate_list",search: `?stock_market=${filters?.stock_market} `, state: {crumbLinks:getPassedCrumbLinks(), stockId:row.id, stockName: row?.name, stockCurrency:row?.trading_currency}}}>
          <h4 className=" text-dark m-0">
          {row?.name || "-"}
          </h4>
          </Link>
        ),
        stock_date:  row.stock_data_latest?.stock_date ? moment(row.stock_data_latest?.stock_date).format('DD.MM.YYYY') : "-",
        updated_opening_price: {
          content: thousandFormat(roundScaleDecimals(row.stock_data_latest?.updated_opening_price,2)),
          className: "text-right"
        } || "-",
        updated_highest_price: {
          content: thousandFormat(roundScaleDecimals(row.stock_data_latest?.updated_highest_price,2)),
          className: "text-right"
        } || "-",
        updated_lowest_price: {
          content: thousandFormat(roundScaleDecimals(row.stock_data_latest?.updated_lowest_price,2)),
          className: "text-right"
        } || "-",
        updated_ending_price: {
          content: thousandFormat(roundScaleDecimals(row.stock_data_latest?.updated_ending_price,4)),
          className: "text-right"
        } || "-",

        // updated_highest_price: row.stock_data_latest?.updated_highest_price || "-",
        // updated_lowest_price: row.stock_data_latest?.updated_lowest_price || "-",
        // updated_ending_price: row.stock_data_latest?.updated_ending_price || "-",

       
        actions: (
          <div className="d-flex justify-content-end">
          <Link to={{pathname:"/dashboard/stocks/rates/rate_list",search: `?stock_market=${filters?.stock_market} `, state: {crumbLinks: getPassedCrumbLinks(), stockId:row.id, stockName: row?.name,  stockCurrency:row?.trading_currency}}}>
            <Button className="btn-sm" color="secondary">
              <span className="fas fa-chart-line"></span> {t("")}
            </Button>
          </Link>
          </div>
          ),
      }
    })
  }, [stocks, filters])
  
  return (
    <>
      <PageHeader title={t("StocksList_title","Noteeratut osakeet (NASDAQ)")} />
      <div className="d-flex">

      <BreadcrumbsDynamic links={getCrumbLinks()} />
      <div className="ml-auto">
        {stocks && stocks.length > 0 && getLatestStockDataUpdateDate()}
      </div>
     </div>

      <PageContainer>
      <div className="d-flex flex-row align-items-center mb-3">
        <div className="p-2 pr-1">
          <h4 className="mb-0">{ t("stock_market_select_label", "Pörssi")}</h4>
          
        </div>
        <div className="p-2">
          <StockMarketSelect  label= {""} onChange={handleChange} value={filters?.stock_market} />
        </div>
        {  !loading && (
          <div className="d-flex align-items-center ml-auto">
            <div className="mx-2" variant="h4">{t("PrivateInvestmentFundsList_count", "Näytä")}</div>
            <Pagination 
              paginationOffset={filters?.offset}
              paginationLimit={filters?.limit}
              paginationCount={count}
              setFilters={setFilters}
              showPaginationCurrentPage={false}
              showPaginationNextAndPrevious={false}
              showVerticalBorders={false}
            />
            <div className="mx-2" variant="h4">{t("riviä")}</div>
            {

            // <div className="ml-4">
            // <CurrencySelect 
            //   label={""}
            //   disabled={true}
            // />
            // </div>
          }

          </div>
        )}

      </div>
      
  
      <TableAuto
          showRowNumber={true}
          showId={true}
          checkboxes={false}
          headers={headers}
          headerColor={"light"}
          rows={getTableRows()}
          loading={loading}
          pagination={true}
          paginationPrevious={paginationPrevious}
          paginationNext={paginationNext}
          paginationOffset={filters?.offset}
          paginationLimit={filters?.limit}
          paginationCount={count}
          setFilters={setFilters}
        />
      </PageContainer>
    </>
  );
}

export default StocksList;
